import Alpine from 'alpinejs'
import { pushDataLayer } from '../helpers/pushDataLayer'

const COOKIE_NAME = 'has_seen_language_switch'
const COOKIE_MAX_AGE_DAYS = 30

function setCookie(name: string, value: string, days: number) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString()
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/;`
}

function getCookie(name: string): string | null {
  const regex = new RegExp('(^| )' + name + '=([^;]+)')
  const match = document.cookie.match(regex)
  if (match) {
    return decodeURIComponent(match[2])
  }
  return null
}

Alpine.store('LanguageSwitch', {
  isVisible: false,
  siteLocale: '',
  countryCode: '',
  initialized: false,
  isLink: false,
  pendingUrl: '',

  /**
   * Function to be called on page load to determine if the language switch banner/modal should be shown.
   * It reads the user's country code from the client_country cookie set by Varnish and checks it against the site's locale.
   */
  initFromServer(siteLocale: string) {
    if (this.initialized) return
    this.initialized = true
    this.siteLocale = siteLocale
    this.countryCode = getCookie('client_country') || ''

    const cookie = getCookie(COOKIE_NAME)
    if (cookie === 'true') {
      this.isVisible = false
      return
    }

    const isOnDanishSite = this.siteLocale === 'default'
    const hasDanishIp = this.countryCode === 'dk'
    const showLanguageSwitch = (isOnDanishSite && !hasDanishIp) || (!isOnDanishSite && hasDanishIp)

    this.isVisible = showLanguageSwitch
    if (this.isVisible === true) {
      pushDataLayer({
        event: 'language_popup_view',
        currentDomain: window.location.hostname,
      })
    }
  },

  showLinkModal(event) {
    const anchor = event.target.closest('a')
    if (!anchor) return
    if (anchor.href.includes('jeudan.dk')) {
      event.preventDefault()
      this.pendingUrl = anchor.href
      this.isLink = true
      this.isVisible = true
    }
  },

  reset() {
    this.isVisible = false
    this.isLink = false
    this.pendingUrl = ''
  },

  dismiss() {
    if (!this.isLink) {
      setCookie(COOKIE_NAME, 'true', COOKIE_MAX_AGE_DAYS)
      pushDataLayer({
        event: 'language_popup_selection',
        languageSelection: this.countryCode === 'dk' ? 'en' : 'dk',
        currentDomain: window.location.hostname,
      })
    }
    this.reset()
  },

  confirm() {
    if (this.isLink) {
      window.open(this.pendingUrl, '_blank')
      pushDataLayer({
        event: 'go_to_dk_site_click',
        currentDomain: window.location.hostname,
      })
      return this.reset()
    }
    const siteUrl =
      this.siteLocale === 'default' ? 'https://www.jeudan.com' : 'https://www.jeudan.dk'

    pushDataLayer({
      event: 'language_popup_selection',
      languageSelection: this.countryCode === 'dk' ? 'dk' : 'en',
      currentDomain: window.location.hostname,
    })
    window.location.href = siteUrl
    this.reset()
  },
})
